import { useState, useEffect } from 'react';
import config from '../../config/config';
import Header from '../directives/header';
import { Container, Row, Col, Button, Card, Modal } from 'react-bootstrap';
import Footer from '../directives/footer';
import '../css/unitronixexplained.css';
import ModalDeck from '../home/modalDeck';
import { getCryptocurrencyData } from '../../apis/apiAction';

const Portfolio = () => {
  const [show, setShow] = useState(false);
  const [positionClass, setPositionClass] = useState('relative');
  const [BannerData, setBannerData] = useState([]);


  useEffect(() => {
    getBannerData();
  }, []);

  const getBannerData = async () => {
    try {
      let res = await getCryptocurrencyData()
      console.log(res.data)
      if (res.data) {
        setBannerData(res.data);
      }
    } catch (error) {
      console.error("Error fetching banner data:", error);
    }
  };

  useEffect(() => {
    const updatePosition = () => {
      setPositionClass(window.innerWidth >= 767 ? 'absolute' : 'relative');
    };

    updatePosition(); // Set initial state
    window.addEventListener('resize', updatePosition);

    return () => window.removeEventListener('resize', updatePosition);
  }, []);

  const handleDownload = (e) => {
    e.preventDefault();
    try {
      window.location.href = 'https://docsend.com/v/khq29/portfolio';
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <>
      <Header />
      <main style={{ paddingTop: '80px' }}>
        <section className="unitronixexplained position-relative">
          <Container className="">
            <Row className="">
              <Col lg={6} className="">
                <div className="heading mb-4">
                  <h1 className="text-white text-uppercase fw-bold mb-0">
                    Cryptocurrency Portfolio Strategy
                  </h1>
                </div>
                <p className="text-primary fs-5 mb-2">
                  {BannerData.heading}
                </p>
                <p className="mb-5">
                  {/* A smart, secure, and diversified way to invest in crypto. The
                  Unitronix Cryptocurrency Portfolio provide investors—both
                  seasoned and new—with strategic AI-driven, risk-optimized
                  exposure to Bitcoin, Ethereum, Solana, altcoins, stablecoins,
                  and high-growth blockchain assets—all accessible through
                  Unitronix stock, eliminating the complexities of direct crypto
                  ownership. */}
                  {BannerData.description}
                </p>
                <p className="text-white">
                  Download the Full Strategy Document for an in-depth look at
                  our investment approach and asset allocations.
                </p>
                <Button
                  onClick={() => setShow(true)}
                  variant="primary"
                  className="text-black"
                >
                  Download
                </Button>
              </Col>
              <Col lg={6} className="mb-4">
                <div className="WhoAreImg">
                  <div className={`position-${positionClass} end-0`}>
                    <img src="assets/images/portfolio.svg" width={`100%`} />
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="corevalue pt-0">
          <Container>
            <Row>
              <Col lg={12} className="">
                <Row>
                  <Col lg={12} className="mb-5">
                    <Card className="blueCard rounded-5">
                      <Card.Body className="p-md-5 ">
                        <div className="p-3 text-center">
                          <div class="mb-4">
                            <h2 class="fw-semibold text-white mb-0">
                              A Balanced Crypto Investment Approach
                            </h2>
                          </div>
                          <p className="">
                            {/* The Unitronix Cryptocurrency Portfolio is the ideal
                            solution for investors looking for a secure,
                            simplified, and actively managed entry into the
                            evolving cryptocurrency space. By leveraging
                            cutting-edge AI, risk mitigation tools, and
                            strategic diversification, Unitronix empowers
                            investors to capture crypto market opportunities
                            with confidence—without the complexities of constant
                            market monitoring, advanced technical knowledge and
                            wallet management. */}
                            {BannerData.investmentApproachDescription}
                          </p>
                          {/* <p className="mb-0">
                            Unitronix's innovative approach empowers investors
                            to seize opportunities in the crypto market with
                            confidence and simplicity, and set a new standard
                            for digital asset management.
                          </p> */}
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </section>
      </main>


      <Modal
        show={show}
        onHide={() => setShow(false)}
        className="border"
        centered
      >
        <Modal.Header closeButton className="border-0"></Modal.Header>
        <Modal.Body className="p-4">
          <ModalDeck
            onSuccess={() => {
              setShow(false);
              handleDownload(new Event('click'));
            }}
          />
        </Modal.Body>
      </Modal>
      <Footer />
    </>
  );
};
export default Portfolio;
